import { cn } from '@utils/utils'
import { SearchTabsProps, SearchType } from '@interfaces/header'
import { Button } from '@components/Ackodrive/Button'
import styles from './SearchComponent.module.scss'

const SearchTabs = ({ activeTab, onTabChange, variant }: SearchTabsProps) => (
  <div className={styles.stickyTabContainer}>
    <div className={styles.tabContainer}>
      <Button
        className={cn(styles.tab, activeTab === 'cars' && styles.active)}
        onClick={() => onTabChange('cars' as SearchType)}>
        Cars
      </Button>
      <Button
        className={cn(styles.tab, activeTab === 'blogs' && styles.active)}
        onClick={() => onTabChange('blogs' as SearchType)}>
        Articles
      </Button>
    </div>
  </div>
)

export default SearchTabs
